import { defineComponent, ref, computed, openBlock, createElementBlock, normalizeClass, toDisplayString } from 'vue';

var IconVariant;
(function (IconVariant) {
  IconVariant["Outlined"] = "outlined";
  IconVariant["OutlinedBold"] = "outlined-bold";
  IconVariant["Filled"] = "filled";
  IconVariant["FilledBold"] = "filled-bold";
  IconVariant["Inherit"] = "inherit";
})(IconVariant || (IconVariant = {}));
var IconSize;
(function (IconSize) {
  IconSize["XL"] = "xl";
  IconSize["L"] = "l";
  IconSize["M"] = "m";
  IconSize["Inherit"] = "inherit";
})(IconSize || (IconSize = {}));

const Icon = [
// Layout
'layout-inline-row justify-center'];
const IconVariants = {
  [IconVariant.Outlined]: [
  // Iconography
  'iconography-outlined'],
  [IconVariant.OutlinedBold]: [
  // Iconography
  'iconography-outlined-bold'],
  [IconVariant.Filled]: [
  // Iconography
  'iconography-filled'],
  [IconVariant.FilledBold]: [
  // Iconography
  'iconography-filled-bold'],
  [IconVariant.Inherit]: [
  // Iconography
  'iconography-inherit']
};
const IconSizes = {
  [IconSize.XL]: [
  // Box
  'w-[28px] md:w-[24px]', 'h-[28px] md:h-[24px]',
  // Typography
  'text-[28px] md:text-[24px]'],
  [IconSize.L]: [
  // Box
  'w-[24px] md:w-[20px]', 'h-[24px] md:h-[20px]',
  // Typography
  'text-[24px] md:text-[20px]'],
  [IconSize.M]: [
  // Box
  'w-[20px] md:w-[16px]', 'h-[20px] md:h-[16px]',
  // Typography
  'text-[20px] md:text-[16px]'],
  [IconSize.Inherit]: [
  // Typography
  'text-inherit']
};

var script = defineComponent({
  name: 'OrIcon',
  props: {
    icon: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: () => IconVariant.Outlined
    },
    size: {
      type: String,
      default: () => IconSize.M
    }
  },
  emits: ['click'],
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-icon-v3', ...Icon, ...IconVariants[props.variant], ...IconSizes[props.size], ...(props.icon.startsWith('or_') ? ['iconography-onereach'] : [])]);
    return {
      root,
      rootStyles
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click', $event))
  }, toDisplayString(_ctx.icon), 3 /* TEXT, CLASS */);
}

script.render = render;
script.__file = "src/components/or-icon-v3/OrIcon.vue";

export { IconSize, IconVariant, script as OrIconV3 };
